const projects = [
  {
    name: "Stellarix",
    desc: "A high-throughput distributed search kernel engineered in Rust to fuse vector similarity (ANN) with symbolic graph traversals. Achieves sub-50ms retrieval for complex multi-hop queries by embedding a multi-modal database engine and ONNX models directly into process memory to eliminate network I/O overhead.",
    tech: "Rust, SurrealDB, ONNX, Tokio, WebSockets, Next.js, TypeScript, Kubernetes, Docker, k6",
    link: "https://github.com/sakshi-kadian/stellarix",
    image: "/images/stellarix.png",
  },
  {
    name: "Lilith",
    desc: "A research-grade E(3)-equivariant geometric deep learning engine that simulates N-body physical systems with exact conservation laws. Achieves a 10,000x speedup over numerical solvers via XLA-compiled Hamiltonian Neural Fields and direct GPU dispatch, featuring an interactive WebGL simulation workbench.",
    tech: "Python, JAX, Haiku, XLA, CUDA, TypeScript, Next.js, React Three Fiber, FastAPI, WebSockets",
    link: "https://github.com/sakshi-kadian/lilith",
    image: "/images/lilith.png",
  },
  {
    name: "Aurelius",
    desc: "A neuro-symbolic reasoning engine that eliminates LLM hallucinations through hybrid RAG architecture. Combines vector embeddings with Neo4j graph traversal for multi-hop reasoning, featuring a 3D 'Golden Beam' visualization for full auditability of AI decision paths.",
    tech: "Python, FastAPI, Neo4j, ChromaDB, Llama 3.1 (Ollama), Next.js, React Three Fiber, Docker",
    link: "https://github.com/sakshi-kadian/aurelius",
    image: "/images/aurelius.png",
  },
  {
    name: "Alchemy",
    desc: "A toxicity-aware graph diffusion model for oncology drug discovery. Generates novel molecular structures with 85%+ validity while enforcing real-time safety constraints through a neuro-symbolic knowledge graph pipeline that filters high-risk substructures.",
    tech: "Python, PyTorch Geometric, NetworkX, BioBERT, RDKit, ChEMBL, FastAPI, React Three Fiber",
    link: "https://alchemy-discovery.vercel.app",
    image: "/images/alchemy.png",
  },
  {
    name: "Celestine",
    desc: "An immersive digital flagship for a jewellery brand, blending interactive 3D artistry with ethereal, seamless editorial transitions to capture the ephemeral beauty of gemstones.",
    tech: "React, Three.js, React Three Fiber, Framer Motion, WebGL",
    link: "https://celestine-jewelry.vercel.app",
    image: "/images/celestine.png",
  },
  {
    name: "Tristella Studio",
    desc: "The official digital presence for Tristella Studio, a creative agency specializing in web experiences. This project showcases a refined 'Champagne & Starlight' aesthetic and a focus on digital storytelling.",
    tech: "Next.js, React, TypeScript, Tailwind CSS, Framer Motion, Lenis",
    link: "https://tristella-studio.vercel.app",
    image: "/images/studio.jpeg",
  },
  {
    name: "Resona",
    desc: "A machine learning system for music taste profiling that models user listening behavior using K-Means clustering, hybrid recommendation algorithms, and temporal evolution analysis to generate personalized insights.",
    tech: "Python, FastAPI, scikit-learn, NumPy, Pandas, TypeScript, Spotify API, OAuth 2.0",
    link: "https://resona-intelligence.vercel.app",
    image: "/images/resona.png",
  },
  {
    name: "HealthScope",
    desc: "A machine learning–based health risk analysis system that evaluates chronic condition risk markers from structured clinical and lifestyle data using supervised learning models and interpretable analytics.",
    tech: "Python, FastAPI, scikit-learn, XGBoost, SHAP, Next.js",
    link: "https://healthscope-analytics.vercel.app",
    image: "/images/healthscope.png",
  },
  {
    name: "Serenia",
    desc: "An AI-powered mental wellness system that uses transformer-based NLP models to detect emotions and anxiety from conversations, track emotional trajectories over time, and provide context-aware, safety-focused support.",
    tech: "Python, FastAPI, PyTorch, Hugging Face Transformers (RoBERTa, BART), PostgreSQL, Next.js",
    link: "https://serenia-platform.vercel.app",
    image: "/images/serenia.png",
  },
  {
    name: "Aurvia",
    desc: "A community networking platform connecting students and club admins, enabling personalized experiences with secure role-based access.",
    tech: "Next.js, React, Tailwind CSS, SupaBase",
    link: "https://aurvia.onrender.com",
    image: "/images/aurvia.jpeg",
  },
  {
    name: "UniAtlas",
    desc: "A responsive web app helping students discover universities worldwide, with dynamic search, filters, sorting, and Supabase-powered real-time data.",
    tech: "Next.js, React, Tailwind CSS, SupaBase",
    link: "https://uniatlas-platform.onrender.com",
    image: "/images/uniconnect.jpeg",
  },
  {
    name: "Wonders in the Wind",
    desc: "An interactive web experience showcasing the seven wonders of the world with dynamic animations and responsive design to enhance user engagement.",
    tech: "React, Tailwind CSS, Framer Motion",
    link: "https://wonders-in-the-wind.onrender.com",
    image: "/images/wonders.JPG",
  },
  {
    name: "Wishique",
    desc: "A curated multi-vendor marketplace with buyer and seller flows, built using the MERN stack for seamless e-commerce experiences.",
    tech: "React, Tailwind CSS, Node.js, Express, MongoDB Atlas",
    link: "https://wishique.onrender.com",
    image: "/images/wishique.jpeg",
  },
  {
    name: "DreamyBlog",
    desc: "A full-stack blog application with CRUD functionality, allowing users to create, edit, and delete posts with a clean and intuitive interface.",
    tech: "HTML, CSS, EJS, Node.js, Express",
    link: "https://dreamyblog-hl9t.onrender.com/",
    image: "/images/dreamyblog.png",
  },
  {
    name: "Bakery Static Website",
    desc: "A responsive static website showcasing a bakery with an elegant design, optimized for different devices and smooth user navigation.",
    tech: "HTML, CSS",
    link: "https://sakshi-kadian.github.io/nevaeh-bakery-website/",
    image: "/images/bakery.png",
  },
];

export default projects;
